import { useErrorHandler } from 'hooks';
import { FC } from 'react';
import { SWRConfig } from 'swr';

export const WithSwrConfig: FC = ({ children }) => {
    const errorHandler = useErrorHandler();

    return (
        <SWRConfig
            value={{
                shouldRetryOnError: false,
                revalidateOnMount: true,
                revalidateOnFocus: false,
                errorRetryCount: 3,
                onError: errorHandler
            }}
        >
            {children}
        </SWRConfig>
    );
};
